module.exports = __webpack_public_path__ + "static/media/empty_calendar.ce059cc3.svg";